import { Icon } from '@doordash/design-language';
import { BannerType, BannerVariant } from './types.js';

var _BannerVariant$Highli, _BannerVariant$Negati, _BannerVariant$Positi, _BannerVariant$Warnin, _BannerVariant$Inform, _bannerConfig;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var IconTypes = _objectSpread({
  None: 'None'
}, Icon.Types);
var bannerConfig = (_bannerConfig = {}, _defineProperty(_bannerConfig, BannerVariant.Highlight, (_BannerVariant$Highli = {}, _defineProperty(_BannerVariant$Highli, BannerType.Default, {
  foreground: 'BannerHighlightDefaultForeground',
  iconType: IconTypes.PromoLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_BannerVariant$Highli, BannerType.Emphasis, {
  foreground: 'BannerHighlightEmphasisForeground',
  iconType: IconTypes.PromoFill,
  secondaryButton: 'BannerHighlightEmphasisForeground'
}), _defineProperty(_BannerVariant$Highli, BannerType.Subdued, {
  foreground: 'BannerHighlightSubduedForeground',
  iconType: IconTypes.PromoLine,
  secondaryButton: 'ButtonFabForeground'
}), _BannerVariant$Highli)), _defineProperty(_bannerConfig, BannerVariant.Negative, (_BannerVariant$Negati = {}, _defineProperty(_BannerVariant$Negati, BannerType.Default, {
  foreground: 'BannerNegativeDefaultForeground',
  iconType: IconTypes.ErrorFill,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_BannerVariant$Negati, BannerType.Emphasis, {
  foreground: 'BannerNegativeEmphasisForeground',
  iconType: IconTypes.ErrorFill,
  secondaryButton: 'BannerNegativeEmphasisForeground'
}), _defineProperty(_BannerVariant$Negati, BannerType.Subdued, {
  foreground: 'BannerNegativeSubduedForeground',
  iconType: IconTypes.ErrorLine,
  secondaryButton: 'ButtonFabForeground'
}), _BannerVariant$Negati)), _defineProperty(_bannerConfig, BannerVariant.Positive, (_BannerVariant$Positi = {}, _defineProperty(_BannerVariant$Positi, BannerType.Default, {
  foreground: 'BannerPositiveDefaultForeground',
  iconType: IconTypes.CheckCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_BannerVariant$Positi, BannerType.Emphasis, {
  foreground: 'BannerPositiveEmphasisForeground',
  iconType: IconTypes.CheckCircleFill,
  secondaryButton: 'BannerPositiveEmphasisForeground'
}), _defineProperty(_BannerVariant$Positi, BannerType.Subdued, {
  foreground: 'BannerPositiveSubduedForeground',
  iconType: IconTypes.Check,
  secondaryButton: 'ButtonFabForeground'
}), _BannerVariant$Positi)), _defineProperty(_bannerConfig, BannerVariant.Warning, (_BannerVariant$Warnin = {}, _defineProperty(_BannerVariant$Warnin, BannerType.Default, {
  foreground: 'BannerWarningDefaultForeground',
  iconType: IconTypes.WarningFill,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_BannerVariant$Warnin, BannerType.Emphasis, {
  foreground: 'BannerWarningEmphasisForeground',
  iconType: IconTypes.WarningFill,
  secondaryButton: 'BannerWarningEmphasisForeground'
}), _defineProperty(_BannerVariant$Warnin, BannerType.Subdued, {
  foreground: 'BannerWarningSubduedForeground',
  iconType: IconTypes.WarningLine,
  secondaryButton: 'ButtonFabForeground'
}), _BannerVariant$Warnin)), _defineProperty(_bannerConfig, BannerVariant.Informational, (_BannerVariant$Inform = {}, _defineProperty(_BannerVariant$Inform, BannerType.Default, {
  foreground: 'BannerInformationalDefaultForeground',
  iconType: IconTypes.InfoCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_BannerVariant$Inform, BannerType.Emphasis, {
  foreground: 'BannerInformationalEmphasisForeground',
  iconType: IconTypes.InfoCircleFill,
  secondaryButton: 'BannerInformationalEmphasisForeground'
}), _defineProperty(_BannerVariant$Inform, BannerType.Subdued, {
  foreground: 'BannerInformationalSubduedForeground',
  iconType: IconTypes.InfoCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _BannerVariant$Inform)), _bannerConfig);
var getIconType = function getIconType(_ref) {
  var variant = _ref.variant,
      type = _ref.type,
      iconType = _ref.iconType;

  if (variant === BannerVariant.Negative || variant === BannerVariant.Warning) {
    return bannerConfig[variant][type].iconType;
  }

  return iconType || bannerConfig[variant][type].iconType;
};

export { IconTypes, bannerConfig, getIconType };
